<ada-container
	horizontalSpacing="medium"
	verticalSpacing="medium"
	[colCount]="4"
>
	<ada-label
		class="ada-vector2-x-label"
		[content]="xLabel"
		[responsiveConfiguration]="_widgetService.ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	>
		<ada-text
			*ngIf="xLabelInfo"
			class="ada-vector2-x-label-info"
			data-container-selector="label-info-text"
			[content]="xLabelInfo"
		></ada-text>
	</ada-label>
	<ada-container
		verticalAlignmentOfChildren="middle"
		[colCount]="0"
		[responsiveConfiguration]="_widgetService.ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
	>
		<ada-input
			#XInput
			class="ada-vector2-x-input"
			placeholder="{{xLabel}}"
			type="number"
			[attr.data-testid]="'vector2-x-input-' + id"
			[colSpan]="0"
			[horizontalGrowEnabled]="true"
			[isDisabled]="isDisabled"
			[max]="max?.x"
			[min]="min?.x"
			[showAsFullWidth]="true"
			[value]="value.x"
			(valueChange)="setX($event)"
		></ada-input>
		<ada-push-button
			class="ada-vector2-clear-x-button"
			icon="faTimes"
			look="flat"
			marginRight="0px"
			size="small"
			tooltip="Clear {{xLabel}}"
			type="error"
			[adaClick]="clearX | adaBindMethod : this"
			[attr.data-testid]="'vector2-x-clear-input-' + id"
			[colSpan]="0"
			[isDisabled]="isDisabled"
			[ngStyle]="{ marginLeft: _widgetService.ui.Spacing.SPACING_MEDIUM }"
			[showAsIconButton]="true"
		></ada-push-button>
	</ada-container>
	<ada-label
		class="ada-vector2-y-label"
		[content]="yLabel"
		[responsiveConfiguration]="_widgetService.ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	>
		<ada-text
			*ngIf="yLabelInfo"
			class="ada-vector2-y-label-info"
			data-container-selector="label-info-text"
			[content]="yLabelInfo"
		></ada-text>
	</ada-label>
	<ada-container
		verticalAlignmentOfChildren="middle"
		[colCount]="0"
		[responsiveConfiguration]="_widgetService.ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
	>
		<ada-input
			#YInput
			class="ada-vector2-y-input"
			placeholder="{{yLabel}}"
			type="number"
			[attr.data-testid]="'vector2-y-input-' + id"
			[colSpan]="0"
			[horizontalGrowEnabled]="true"
			[isDisabled]="isDisabled"
			[max]="max?.y"
			[min]="min?.y"
			[showAsFullWidth]="true"
			[value]="value.y"
			(valueChange)="setY($event)"
		></ada-input>
		<ada-push-button
			class="ada-vector2-clear-y-button"
			icon="faTimes"
			look="flat"
			marginRight="0px"
			size="small"
			tooltip="Clear {{yLabel}}"
			type="error"
			[adaClick]="clearY | adaBindMethod : this"
			[attr.data-testid]="'vector2-y-clear-input-' + id"
			[colSpan]="0"
			[isDisabled]="isDisabled"
			[ngStyle]="{ marginLeft: _widgetService.ui.Spacing.SPACING_MEDIUM }"
			[showAsIconButton]="true"
		></ada-push-button>
	</ada-container>
</ada-container>
